import React, { useState } from 'react';
import { GroupOption, RadioButtonsStateLess } from 'src/components/FormComponents/RadioButtonsGroup/RadioButtons/RadioButtons';
import { observer } from 'src/utils/mobx-react';
import { SrgQuestionnaireState } from './SrgQuestionnaire.state';
import { SrgQuestionnaireInfo, SrgQuestionnaireContainer, SrgQuestionnaireItem, SrgQuestionnaireItemCounter, SrgQuestionnaireItemText, SrgQuestionnaireItemsWrapper, SrgQuestionnaireButtons, SrgQuestionnaireItemRadioButtons, CheckIconWrapper, WrongIconWrapper, SrgStatus } from './SrgQuestionnaire.style';
import { useAppStateContext } from 'src/AppState/AppState';

const groupValues: Array<GroupOption<'yes' | 'no'>> = [
    {
        value: 'yes',
        label: 'Yes'
    },
    {
        value: 'no',
        label: 'No'
    },
];

interface PropsTypes {
    customerId: number
}

export const SrgQuestionnaire = observer('SrgQuestionnaire', ({ customerId }: PropsTypes): JSX.Element | null => {
    const { sdkStaff } = useAppStateContext();
    const [localState] = useState(() => new SrgQuestionnaireState(sdkStaff, customerId));

    return (
        <div className='row'>
            <h2 className='header' data-test='srg-questionnaire-header'>SRG Questionnaire</h2>
            {localState.userAnswersReady === null ? 'Loading...' :
                localState.userAnswersReady.length === 0 ?
                    <SrgQuestionnaireInfo data-test='srg-questionnaire-info'>
                        The user has not filled in SRG Questionanire yet.
                    </SrgQuestionnaireInfo> :
                    <SrgQuestionnaireQestions localState={localState} />}
            <SrgQuestionnaireButtons>
            </SrgQuestionnaireButtons>
        </div>
    );
});

interface SrgQuestionnaireProps {
    localState: SrgQuestionnaireState
}
export const SrgQuestionnaireQestions = observer('SrgQuestionnaireQestions', ({ localState }: SrgQuestionnaireProps): JSX.Element | null => {

    return (
        <>
            <SrgQuestionnaireContainer>
                {
                    localState.userAnswersReady === null ?
                        null :
                        <SrgQuestionnaireItemsWrapper>
                            {localState.userAnswersReady.map((item, index) => (
                                <SrgQuestionnaireItem key={index} data-test={`srg-questionnaire-item-${index + 1}`}>
                                    <SrgQuestionnaireItemCounter data-test={`srg-questionnaire-item-counter-${index + 1}`}>
                                        {index + 1} of {localState.userAnswersReady.length}
                                    </SrgQuestionnaireItemCounter>
                                    <SrgQuestionnaireItemText data-test={`srg-questionnaire-item-text-${index + 1}`}>
                                        {item.question}
                                    </SrgQuestionnaireItemText>
                                    <SrgQuestionnaireItemRadioButtons>
                                        {item.answer === undefined ? 'no answered' : <RadioButtonsStateLess gap='22' size='small' name='srg-question' group={groupValues} selectValue={item.answer} showPointer={false} />}
                                    </SrgQuestionnaireItemRadioButtons>
                                    {item.passed ? <CheckIconWrapper dataTest={`check-icon-wrapper-${index + 1}`} /> : <WrongIconWrapper dataTest={`wrong-icon-wrapper-${index + 1}`} />}
                                </SrgQuestionnaireItem>
                            ))}
                        </SrgQuestionnaireItemsWrapper>
                }
            </SrgQuestionnaireContainer>
            {localState.isSrgPassed ?
                <>Player has <SrgStatus isPassed={localState.isSrgPassed} data-test='srg-status-passed'>passed</SrgStatus> SRG Questionaire</> :
                <>Player has <SrgStatus isPassed={localState.isSrgPassed} data-test='srg-status-failed'>failed</SrgStatus> SRG Questionaire</>}
        </>
    );
});
